import { render, staticRenderFns } from "./delivery-dialog.vue?vue&type=template&id=6cdc5c6d"
import script from "./delivery-dialog.vue?vue&type=script&lang=js"
export * from "./delivery-dialog.vue?vue&type=script&lang=js"
import style0 from "./delivery-dialog.vue?vue&type=style&index=0&id=6cdc5c6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports